<template>
  <span :class="get_class">
    <div v-if="display_value.length > 0">
      <template v-for="(orders, index) in display_value">
        <div :key="index">
          {{ orders.date_invoiced ? orders.date_invoiced + "\n" : "None \n" }}
        </div>
      </template>
    </div>
  </span>
</template>

<script>
import DisplayMixin from "../../../vue-ocom/mixins/display_mixin";
export default {
  name: "LookupArrayDisplay",
  props: {
    value: {}, // The value that is looked up in the "list"
    list: {
      type: Object,
      default: () => {},
    }, // the dict/Object to look up - List might not be the right name
    displayField: { type: String, default: "description" }, // The field to show the value of
    defaultValue: { type: String, default: "" }, // The Default value to show if there is no match in the list
  },
  mixins: [DisplayMixin("display_value")],

  computed: {
    display_value() {
      if (this.list) {
        var item = this.list[this.value];

        if (item) {
          return item[this.displayField];
        }
      }

      return this.defaultValue;
    },
  },
};
</script>

<style scoped></style>
